import { useQuery, useQueryClient } from '@tanstack/react-query';
import { GET_PAGE_ENDPOINT } from '@/app/_libs/utils/constants/endpoints';

// Get page list*****************************************
async function getPagesList({ limit, type }) {
  const res = await fetch(`${GET_PAGE_ENDPOINT}?limit=${limit}&type=${type}`, {
    method: 'get',
  });
  const pages = await res.json();
  return pages.data;
}
//Get page  ******************************************
async function getPage(slug) {
  const data = await fetch(`${GET_COMMENT_ENDPOINT}/${slug}`);
  const pageContent = await data.json();
  return { pageContent };
}

// use user comments hook**************************
const usePagesList = (limit, type) => {
  const fallback = [];
  const { data: pagesList = fallback } = useQuery({
    queryKey: ['pagesList', limit, type],
    queryFn: () => getPagesList({ limit, type }),
  });
  return { pagesList };
};

const usePage = (slug, initiaData) => {
  const queryClient = useQueryClient();
  const fetchPage = async (slug) => {
    await queryClient.prefetchQuery(['page', slug], () => getPage(slug));
  };
  const fallback = [];
  const { data: pageContent = fallback } = useQuery({
    queryKey: ['page', slug],
    queryFn: () => getPage(slug),
    initialData: initiaData,
  });
  return { pageContent, fetchPage };
};

export { usePagesList, usePage };
